import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

import { Menu } from "lucide-react";
import { motion } from "framer-motion";

import Sidebar from "../components/Sidebar"; // ✅ Ensure this is correct
import Home from "./home";
import TeamManagment from "./team-managment";
import Reports from "./repots";
import Deals from "./deals";
import CreateUser from "./create-user";
import CreateLeadSource from "./create-lead-source";
import {
  getAlldealforAdmin,
  getAllusers,
  getSourceLead,
  updateItem,
  getListingAppointments,
} from "../utils/firebasefunctions";
import { actionType } from "../context/reducer";
import { toast } from "react-toastify";
import { useStateValue } from "../context/StateProvider";
import DealDetail from "./lead-detail";
import Profile from "./profile";
import TeamManagmentDetail from "./team-managment-detail";
import UserManagment from "./team-manament";
import DealBoard from "./deal-board";
import BuyerLeads from "./buyer-leads";
import MainListingLeads from "../components/listing-leads/main-listing-leads";
import { getToken } from "firebase/messaging";
import EnableNotificationsCard from "../components/notifications/EnableNotificationsCard";
import { messaging } from "../firebase/firebaseConfig";
import { arrayUnion } from "firebase/firestore";
import MentionProfile from "./profile-page";
import ListingRequest from "./listing-request";
import Contact from "./contact-page";
import Settings from "./settings";
import Goals from "./goals";
import Feed from "./feed";
import Notifications from "./notifications";
import OpenHouses from "./open-houses";
import RecentlyDeleted from "./recently-deleted";
import Directory from "./directory";
import StatusSheet from "./status-sheet";

function Dashboard() {
  const [{ user, steps }, dispatch] = useStateValue();
  const navigate = useNavigate();
  if (!user) {
    navigate("/");
  }
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCollapseBar, setIsCollapseBar] = useState(false);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth >= 1024);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const getCollpase = (value) => {
    setIsCollapseBar(value);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth >= 1024);
      setIsMobileMenuOpen(false);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Wait for sign-in before touching Firestore — firing these unauthenticated
  // gets a permission-denied from the rules (the "Missing or insufficient
  // permissions" popup people saw when opening the site logged out).
  useEffect(() => {
    if (!user?.id) return;
    getallusers();
    fetchLeadData();
  }, [user?.id]);

    useEffect(() => {
    if (user?.id) {
      if (user?.id != undefined) {
        requestPermission();
      }
   
    }
  }, [user]);

    async function requestPermission() {
    // Dev-only: skip push-notification (FCM) setup when running locally. getToken
    // uses the LIVE project's web-push/VAPID credentials, which the sandbox project
    // doesn't have — it throws "messaging/token-subscribe-failed" as an uncaught
    // runtime error. Production builds keep push notifications enabled.
    if (process.env.NODE_ENV === "development") return;
    //requesting permission using Notification API
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const token = await getToken(messaging, {
        vapidKey:
          "BKNonFk-lAUXh-_LSJ6F1aoG1ZfVupq3qc3FsR2WgQw48IpnqLWRQ5MrYDqFzG4xNfAxovO6AB51e5lhp1JDG3Y",
      });

      //We can send token to server
      console.log("Token generated : ", token);
      if (
        user?.NotificationToken == undefined ||
        user?.NotificationToken?.find((data) => data == token) == undefined
      ) {
        updatenotificationtoken(token);
      }
    }
    // No blocking alert on denial: in a Safari tab on iPhone the request
    // silently no-ops (push needs an installed PWA), so a denial here is
    // expected. The EnableNotificationsCard guides users to the right path.
  }

   const updatenotificationtoken = async (token) => {
    let data = {
      NotificationToken: arrayUnion(token),
    };
    await updateItem("users", user?.id, data)
      .then(async (response) => {})
      .catch((err) => {
        console.error("Failed to save notification token:", err);
      });
  };

  async function getallusers() {
    await getAllusers("users")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_ALLUSERS,
          teamleads: response.filter(function (doc) {
            return doc.role == "Admin";
          }),
          clients: response.filter(function (doc) {
            return doc.role == "Supervisor";
          }),
          employees: response.filter(function (doc) {
            return doc.role == "Employee" || doc.role == "Admin";
          }),
          allusers: response,
        });
      })
      .catch((err) => {
        console.error("Failed to load users:", err);
      });
  }
  const fetchLeadData = async () => {
    const data = await getSourceLead();
    dispatch({
      type: actionType.STORE_LEADS,
      payload: data,
    });
  };

  async function getalldeal() {
    await getAlldealforAdmin("deals")
      .then(async (response) => {
        dispatch({
          type: actionType.STORE_DEALS,
          deals: response,
        });
      })
      .catch((err) => {
        console.error("Failed to load deals:", err);
      });
  }

  async function getListingAppts() {
    try {
      const items = await getListingAppointments();
      dispatch({
        type: actionType.STORE_LISTING_APPOINTMENTS,
        payload: items,
      });
    } catch (err) {
      console.error("Failed to load listing appointments:", err);
    }
  }

  useEffect(() => {
    if (!user?.id) return;
    getalldeal();
    getListingAppts();
  }, [user?.id]);
  return (
    <div className="flex lg:flex-row flex-col w-full">
      <div className={`${isCollapseBar ? "lg:w-[5.5%]" : "lg:w-[20%]"}`}>
        <button
          className={`fixed top-3 left-4 z-50 ${
            isMobileMenuOpen ? "hidden" : ""
          } lg:hidden bg-gray-300 p-2 rounded-full`}
          onClick={toggleMobileMenu}
        >
          <Menu className="h-6 w-6" />
        </button>
        <Sidebar
          isMobileMenuOpen={isMobileMenuOpen}
          setIsMobileMenuOpen={setIsMobileMenuOpen}
          isCollapse={getCollpase}
        />
      </div>
      <motion.div
        initial={{ x: 0 }}
        animate={isLargeScreen && isCollapseBar ? { x: 0 } : {}}
        transition={{ type: "spring", stiffness: 260, damping: 30 }}
        className={`${
          isCollapseBar ? " w-full" : "lg:w-[80%] w-full"
        }  overflow-y-auto}`}
      >
        <EnableNotificationsCard />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/create-user" element={<CreateUser />} />
          <Route path="/update-user/:id" element={<CreateUser />} />
          {/* <Route path="/user-management" element={<UserManagment />} /> */}
          <Route path="/team-management" element={<TeamManagment />} />
          <Route
            path="/team-management/:id"
            element={<TeamManagmentDetail />}
          />
          <Route path="/goals" element={<Goals />} />
          <Route
            path="/reports"
            element={<Navigate to="/dashboard/team-management?tab=reports" replace />}
          />
          <Route path="/deals" element={<Deals />} />
          <Route path="/deals-detail/:id" element={<DealDetail />} />
          {/* <Route path="/create-lead-source" element={<CreateLeadSource />} /> */}
          <Route path="/profile" element={<Profile />} />
          <Route path="/profile/:id" element={<MentionProfile />} />
          <Route path="/deal-board" element={<DealBoard />} />
          <Route path="/buyers" element={<BuyerLeads />} />
          <Route path="/listings" element={<MainListingLeads />} />
          {/* Task Templates lives in Settings → Task Templates now. */}
          <Route
            path="/task-template"
            element={
              <Navigate to="/dashboard/settings?tab=taskTemplate" replace />
            }
          />
          <Route path="/listing-request" element={<ListingRequest />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/directory" element={<Directory />} />
          {/* Super Admin moved into Settings — keep old links working. */}
          <Route
            path="/super-admin"
            element={
              <Navigate to="/dashboard/settings?tab=superAdmin" replace />
            }
          />
          <Route path="/status-sheet" element={<StatusSheet />} />
          <Route path="/open-houses" element={<OpenHouses />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/notifications" element={<Notifications />} />
          <Route path="/recently-deleted" element={<RecentlyDeleted />} />
        </Routes>
      </motion.div>
    </div>
  );
}

export default Dashboard;
